import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadAccrualANZById: IAccrualANZLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_ACCRUALANZ_LOAD_BY_ID,
            id
        }
    },
    LoadAccrualANZByTrialId: IAccrualANZLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID,
            trialId
        }
    },
    LoadSuccess: IAccrualANZLoadSuccessActionCreator = (data, responseStatus) => {
        return {
            type: ACTION_ACCRUALANZ_LOAD_SUCCESS,
            data,
            responseStatus
        }
    },
    LoadFailure: IAccrualANZLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_ACCRUALANZ_LOAD_FAILURE,
            responseStatus
        }
    },
    Clear: IAccrualANZClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_ACCRUALANZ_CLEAR,
            propertiesToClear
        }
    };

export const
    ACTION_ACCRUALANZ_LOAD_BY_ID = "ACTION_ACCRUALANZ_LOAD_BY_ID",    
    ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID = "ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID",
    ACTION_ACCRUALANZ_LOAD_SUCCESS = "ACTION_ACCRUALANZ_LOAD_SUCCESS",
    ACTION_ACCRUALANZ_LOAD_FAILURE = "ACTION_ACCRUALANZ_LOAD_FAILURE",

    ACTION_ACCRUALANZ_SAVE = "ACTION_ACCRUALANZ_SAVE",
    ACTION_ACCRUALANZ_SAVE_SUCCESS = "ACTION_ACCRUALANZ_SAVE_SUCCESS",
    ACTION_ACCRUALANZ_SAVE_FAILURE = "ACTION_ACCRUALANZ_SAVE_FAILURE",

    ACTION_ACCRUALANZ_CREATE = "ACTION_ACCRUALANZ_CREATE",
    ACTION_ACCRUALANZ_CREATE_SUCCESS = "ACTION_ACCRUALANZ_CREATE_SUCCESS",
    ACTION_ACCRUALANZ_CREATE_FAILURE = "ACTION_ACCRUALANZ_CREATE_FAILURE",

    ACTION_ACCRUALANZ_CLEAR = "ACTION_ACCRUALANZ_CLEAR",
    ACTION_ACCRUALANZ_FILTER = "ACTION_ACCRUALANZ_FILTER";

export interface IAccrualANZLoadByIdAction {
    type: "ACTION_ACCRUALANZ_LOAD_BY_ID";
    id: number;
}

export interface IAccrualANZLoadByIdActionCreator {
    (id: number): IAccrualANZLoadByIdAction;
}

export interface IAccrualANZLoadByTrialIdAction {
    type: "ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID";
    trialId: number;
}

export interface IAccrualANZLoadByTrialIdActionCreator {
    (trialId: number): IAccrualANZLoadByTrialIdAction;
}

export interface IAccrualANZLoadSuccessAction {
    type: "ACTION_ACCRUALANZ_LOAD_SUCCESS";
    data: Dtos.AccrualANZ | Dtos.AccrualANZ[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IAccrualANZLoadSuccessActionCreator {
    (
        data: Dtos.AccrualANZ | Dtos.AccrualANZ[],
        responseStatus: Dtos.ResponseStatus
    ): IAccrualANZLoadSuccessAction;
}

export interface IAccrualANZLoadFailureAction {
    type: "ACTION_ACCRUALANZ_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IAccrualANZLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IAccrualANZLoadFailureAction;
}

export interface IAccrualANZClearAction {
    type: "ACTION_ACCRUALANZ_CLEAR";
    propertiesToClear?: string[];
}

export interface IAccrualANZClearActionCreator {
    (propertiesToClear?: string[]): IAccrualANZClearAction;
}

export type AccrualANZAction =
    IAccrualANZLoadByIdAction |
    IAccrualANZLoadByTrialIdAction |
    IAccrualANZLoadFailureAction |
    IAccrualANZLoadSuccessAction |
    IAccrualANZClearAction;
